import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryCreditModel } from '../../models/summary-credit.model';


export enum CreditActionTypes {
  LoadCredits = '[Credit] Load Credits',
  LoadCreditsSuccess = '[Credit] Load Credits Success',
  LoadCreditsFailure = '[Credit] Load Credits Failure',

  LoadCredit = '[Credit] Load Credit',
  LoadCreditSuccess = '[Credit] Load Credit Success',
  LoadCreditFailure = '[Credit] Load Credit Failure',

  CreateCredit = '[Credit] Create Credit',
  CreateCreditSuccess = '[Credit] Create Credit Success',
  CreateCreditFailure = '[Credit] Create Credit Failure',

  UpdateCredit = '[Credit] Update Credit',
  UpdateCreditSuccess = '[Credit] Update Credit Success',
  UpdateCreditFailure = '[Credit] Update Credit Failure',

  DeleteCredit = '[Credit] Delete Credit',
  DeleteCreditSuccess = '[Credit] Delete Credit Success',
  DeleteCreditFailure = '[Credit] Delete Credit Failure',
}

/** Load all */

export class LoadCredits implements Action {
  readonly type = CreditActionTypes.LoadCredits;
  constructor(public payload: {filter: any}) {}
}

export class LoadCreditsSuccess implements Action {
  readonly type = CreditActionTypes.LoadCreditsSuccess;
  constructor(public payload: { items: SummaryCreditModel[]; total: number }) {}
}

export class LoadCreditsFailure implements Action {
  readonly type = CreditActionTypes.LoadCreditsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadCredit implements Action {
  readonly type = CreditActionTypes.LoadCredit;
  constructor(public payload: { uid: string }) {}
}

export class LoadCreditSuccess implements Action {
  readonly type = CreditActionTypes.LoadCreditSuccess;
  constructor(public payload: SingleResponseModel<SummaryCreditModel>) {}
}

export class LoadCreditFailure implements Action {
  readonly type = CreditActionTypes.LoadCreditFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateCredit implements Action {
  readonly type = CreditActionTypes.CreateCredit;
  constructor(public payload: { credit: SummaryCreditModel }) {}
}


export class CreateCreditSuccess implements Action {
  readonly type = CreditActionTypes.CreateCreditSuccess;
  constructor(public payload: { credit: SummaryCreditModel }) {}
}

export class CreateCreditFailure implements Action {
  readonly type = CreditActionTypes.CreateCreditFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateCredit implements Action {
  readonly type = CreditActionTypes.UpdateCredit;
  constructor(public payload: { credit: SummaryCreditModel }) {}
}

export class UpdateCreditSuccess implements Action {
  readonly type = CreditActionTypes.UpdateCreditSuccess;
  constructor(public payload: { credit: SummaryCreditModel }) {}
}

export class UpdateCreditFailure implements Action {
  readonly type = CreditActionTypes.UpdateCreditFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteCredit implements Action {
  readonly type = CreditActionTypes.DeleteCredit;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCreditSuccess implements Action {
  readonly type = CreditActionTypes.DeleteCreditSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCreditFailure implements Action {
  readonly type = CreditActionTypes.DeleteCreditFailure;
  constructor(public payload: { error: any }) {}
}

export type CreditActions =
  | LoadCredits
  | LoadCreditsSuccess
  | LoadCreditsFailure
  | LoadCredit
  | LoadCreditSuccess
  | LoadCreditFailure
  | CreateCredit
  | CreateCreditSuccess
  | CreateCreditFailure
  | UpdateCredit
  | UpdateCreditSuccess
  | UpdateCreditFailure
  | DeleteCredit
  | DeleteCreditSuccess
  | DeleteCreditFailure
